import { render, staticRenderFns } from "./show_conflict.html?vue&type=template&id=f0072bd4&scoped=true&"
import script from "./show_conflict.js?vue&type=script&lang=js&"
export * from "./show_conflict.js?vue&type=script&lang=js&"
import style0 from "./show_conflict.scss?vue&type=style&index=0&id=f0072bd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f0072bd4",
  null
  
)

export default component.exports